import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";
import { isMatchAbbreviation } from "../Types";

import { UrbanSettlementTypes } from "./UrbanSettlementTypes";

export function getUrbanSettlementTypeCode(UrbanSettlement: string | number | undefined): string | undefined {
    const stringUrbanSettlement = UrbanSettlement?.toString();
    const UrbanSettlementCode = UrbanSettlementTypes.find(abbreviation =>
        isMatchAbbreviation(abbreviation, stringUrbanSettlement)
    )?.fiasKey?.toString();
    if (isNullOrEmpty(UrbanSettlementCode)) {
        return undefined;
    }
    return UrbanSettlementCode;
}

export function getUrbanSettlementTypeShortName(UrbanSettlement: string | number | undefined): string | undefined {
    const stringUrbanSettlement = UrbanSettlement?.toString();
    const UrbanSettlementName = UrbanSettlementTypes.find(abbreviation =>
        isMatchAbbreviation(abbreviation, stringUrbanSettlement)
    )?.short.toString();
    if (isNullOrEmpty(UrbanSettlementName)) {
        return undefined;
    }
    return UrbanSettlementName;
}
